import { render, staticRenderFns } from "./RecordBase.vue?vue&type=template&id=499739a8&scoped=true"
import script from "./RecordBase.vue?vue&type=script&lang=js"
export * from "./RecordBase.vue?vue&type=script&lang=js"
import style0 from "./RecordBase.vue?vue&type=style&index=0&id=499739a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499739a8",
  null
  
)

export default component.exports